export default "__VITE_ASSET__BHAJ8zYk__"